const settings = {
  brandSite: true,
  channels: [
    {
      channel: 'Anora Pro FI',
      // channel: 'Viinimaa FI',
      store: 'anorapro_fi',
      locale: 'fi-FI',
      languageCode: 'fi',
      slugs: {
        ContentfulArticlePage: 'artikkelit',
        MagentoProduct: 'juomat',
      },
    },
  ],
  localization: {
    default: 'fi-FI',
    defaultLanguageCode: 'fi',
  },
};

export default settings;
